import React, { FC } from 'react';
import { Metadata as LCMetadata } from '@lambdacurry/gatsby-theme/src/components';
import { MetadataProps } from '@lambdacurry/gatsby-theme/src/types';
import classNames from 'classnames';

import './layout.scss';

export interface LayoutProps {
  title?: string;
  metadata?: MetadataProps;
  className?: string;
}

export const Layout: FC<LayoutProps> = ({ children, title, metadata, className, ...props }) => (
  <>
    <LCMetadata title={title} {...metadata} />
    <main className={classNames('layout', className)} {...props}>
      {children}
    </main>
  </>
);
